import configuration from "../../configuration";
import ODataFulogicsStore from "fulogics-ui-core/dist/api/odata/ODataFulogicsStore";
import {createModel} from "@rematch/core";
import {iRootModel} from "../iRootModel";
import Singleton from "fulogics-ui-core/dist/Singleton";
import fromODataResponse from "fulogics-ui-core/dist/api/odata/fromODataResponse";

export const ProductInfoODataEndpoint = `${configuration.API_BASE_URL}/odata/ProductInfos/Store`;
export const ProductInfoStore = ODataFulogicsStore({
    url: ProductInfoODataEndpoint,
    key: 'id',
    keyType: 'String'
});
/*
 createDataSourceForStock() // StockScreenGridItemData
        {

        },
        **/
export type ProductInfoState = {}

export const ProductInfoModel = createModel<iRootModel>()({
    state: {
        //store: ProductInfoStore
    } as ProductInfoState,

    effects: (dispatch) => ({
        async getWMSDetails(payload: getWMSDetailsPayload) // strzelanie po detale do logsoftu 
        {
            let getResponse = await Singleton.apiClient.get<{ title?: string, detail?: string} & PayloadWMSDetailsData>(`/odata/ProductInfos/WMSDetails(warehouseId='${payload.warehouseId}',productId='${payload.productId}')`, {});
            fromODataResponse(getResponse, [200, 204]);
            //
            return getResponse.data as PayloadWMSDetailsData
        }
    }),

    // @ts-ignore
    selectors: (slice, createSelector, hasProps) => ({
        dxStore() //PayloadAddFormDropDownItemData // wszystkie produkty jakie zna warehouse
        {
            return ProductInfoStore;
        },

        
    }),
})

export type getWMSDetailsPayload =
    {
        warehouseId?: string
        productId?: string
    }
export type PayloadWMSDetailsData = {
    totalAvailableProductUnitsSum?: number, // 1800
    totalCarrierTypeProductUnitsSum?: number, // 45
}
export default ProductInfoModel;